import React, { useEffect, useState, useMemo } from 'react'
import FileViewer from 'react-file-viewer'
import { useParams } from 'react-router'
import { useLocation } from 'react-router-dom'
import $t from '../../../i18n'
import cx from 'classnames'
import { backendUrl, mobileOS } from '../../../consts'
import { Button, Spin, Tooltip } from 'antd'
import './FilePreviewPage.css'
import axios from 'axios'
import { getMobileOperatingSystem } from '../../../utils/detectMobileWeb'
import { DownloadOutlined } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import actions from '../../../actions'
import { getTokenFromLocalStorage } from '../../../services/loginService'

export const FilePreviewPage = ({
  isDownloadEnable = false,
  pdfBlob = null,
}) => {
  const { fileId } = useParams()
  const [fileUrl, setFileUrl] = useState(null)
  const { search } = useLocation()
  const searchParams = useMemo(() => new URLSearchParams(search), [search])
  const pdfLink = useSelector(state => state.medicalInfo.selectedPdf)
  const shouldShowPdfByUrl = searchParams.get('shouldShowPdfByUrl') === 'true'
  const [isPdfLoading, setIsPdfLoading] = useState(true)
  const [hasNavigatedBack, setHasNavigatedBack] = useState(false)
  const dispatch = useDispatch()
  const token = getTokenFromLocalStorage()
  const isAndroidMobile = getMobileOperatingSystem() === mobileOS.android
  const fileIdIsNotZero = fileId !== '0'

  useEffect(() => {
    if (!isAndroidMobile && !pdfBlob && !shouldShowPdfByUrl && fileId) {
      const pdfUrl = `${backendUrl}/get-patient-file/?pk=${fileId}&token=${token}`
      axios
        .get(pdfUrl, {
          responseType: 'blob',
        })
        .then(res => {
          setFileUrl(createPdfObject(res.data))
        })
        .catch(err => {
          console.log('Error loading pdf: ', err)
        })
    }

    if (shouldShowPdfByUrl) {
      setFileUrl(pdfLink)
    }

    if (pdfBlob) {
      setFileUrl(pdfBlob)
    }

    return () =>
      dispatch(actions.createAction(actions.CLEAR_VIEW_DOCUMENT_BY_URL))
  }, [
    dispatch,
    fileId,
    pdfBlob,
    token,
    shouldShowPdfByUrl,
    pdfLink,
    isAndroidMobile,
  ])

  const createPdfObject = blob => {
    let file_name = Math.random().toString(36).substring(6) + '_name.pdf' //e.g ueq6ge1j_name.pdf
    let file_object = new File([blob], file_name, {
      type: 'application/pdf',
    })
    return window.URL.createObjectURL(file_object) + '#view=fitH'
  }

  const renderPdfByUrl = () => {
    // eslint-disable-next-line jsx-a11y/iframe-has-title
    return (
      <React.Fragment>
        {isPdfLoading ? <Spin size="large" /> : null}
        <iframe
          className={isPdfLoading ? 'hide-iframe' : 'show-iframe'}
          src={pdfLink}
          height="100%"
          width="100%"
          type="application/pdf"
          onLoad={() => setIsPdfLoading(false)}
        ></iframe>
      </React.Fragment>
    )
  }

  const renderPdfByBlob = () => {
    if (pdfBlob) {
      return (
        <div>
          <FileViewer fileType={'pdf'} filePath={fileUrl} />
        </div>
      )
    } else {
      return <div className="empty"> {$t('common.noFile')} </div>
    }
  }

  // Android mobile with blob isn't showing, so we need to initiate download in a new tab
  if (isAndroidMobile && pdfBlob && !hasNavigatedBack) {
    window.open(`${pdfBlob}`, '_blank')
    setHasNavigatedBack(true)
    dispatch(actions.createAction(actions.NAVIGATED_BACK))
    return null
  }

  return (
    <div
      className={cx('file-preview-container', { empty: !fileIdIsNotZero })}
      style={{ height: '100%', width: '100%' }}
    >
      {fileIdIsNotZero ? (
        <>
          {isAndroidMobile && !pdfBlob ? (
            <>
              <Tooltip title={$t('common.download')} placement="bottom">
                <Button
                  className="download-btn"
                  icon={<DownloadOutlined />}
                  onClick={() =>
                    window.open(
                      `${backendUrl}/get-patient-file/?pk=${fileId}&token=${token}`
                    )
                  }
                  type="primary"
                  shape="circle"
                />
              </Tooltip>
              <FileViewer
                fileType={'pdf'}
                filePath={`${backendUrl}/get-patient-file/?pk=${fileId}&token=${token}`}
              />
            </>
          ) : fileUrl ? (
            // eslint-disable-next-line jsx-a11y/iframe-has-title
            <iframe
              src={fileUrl}
              height="100%"
              width="100%"
              type="application/pdf"
            ></iframe>
          ) : (
            <Spin size="large" />
          )}
        </>
      ) : shouldShowPdfByUrl ? (
        renderPdfByUrl()
      ) : (
        renderPdfByBlob()
      )}
    </div>
  )
}

export default FilePreviewPage
